<template>
 <div  class="main"> 
  <div class="breadcrumb">
<el-breadcrumb separator-class="el-icon-arrow-right" >
        <el-breadcrumb-item>装备</el-breadcrumb-item>
        <el-breadcrumb-item>装车率分析</el-breadcrumb-item>
     </el-breadcrumb> 
  </div>
<SearchBar :moduleName="currentModuleName" v-if="!viewResult"> 
<el-button @click="gotoInstalledRatioAnalysis" type="primary">安装率分析</el-button>
</SearchBar>

<div   v-if="viewResult" style="margin-top:40px;">
  
        <xy-toolbox-menu>
        <xy-toolbox-menu-item divided/>
        <xy-toolbox-menu-item icon="excel" @click="goto">添加车款</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="date" @click="modifyDate">调整时间</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
 
 <el-table
      :data="tableData"
      :span-method="objectSpanMethod"
      border
      height="650"
      style="width: 98%; margin:20px 10px 10px 10px;">
      <el-table-column prop="tag"  label="装备分类"  align="center" width="180"> </el-table-column>
        <el-table-column prop="name"  label="装备名称"></el-table-column>
         <el-table-column prop="val"  label="装备名称"></el-table-column>
      <el-table-column  align="center" label="装车率">
        <el-table-column icon="el-icon-search" align="center"  :prop="n" :key = "n"  :label="n"   v-for='n in date_list'>
       </el-table-column>
      </el-table-column>  
      
    </el-table>
</div>

<el-dialog title="修改时间"
            :visible.sync="showModifyDate"
            :center="false"
            :append-to-body="true">
            <span slot="dialog-title"> </span>
            <el-row>
            <el-col :span="24"  type="flex" justify="end">
            <el-date-picker v-model="currentMonth" type="month" placeholder="选择月" value-format="yyyy-M"> </el-date-picker> &nbsp;&nbsp; <el-button icon="el-icon-plus"  @click="addDate" >添加</el-button>
            </el-col>
          </el-row>
         <div>
                <ul class="date-list">
                  <li :prop="n" :key = "n"  :label="n"   v-for='(n,index) in date_list_tmp'>{{n}} <el-button size="small"  icon="el-icon-delete" circle type="danger"  class="r-delete-btn" @click="removeDate(index)"> </el-button> </li>
                </ul>
         
         </div>
   
            <span slot="footer">          
                <el-button  type="primary" @click="updateData">更新数据</el-button>
            </span>
        </el-dialog>
 
</div>
</template>
<script>
import { mapMutations, mapGetters ,mapActions} from 'vuex';
import SearchBar from '@/components/common/NewSearchBar.vue';
 
//import mock_data from '../../store/mock/installedratiomock.js';
export default {
    name: 'saleanalysis',
       components: {SearchBar},
    data(){
        return {
             tableCfg:null,
            viewResult:false, 
            showModifyDate:false,
            currentMonth:'',
            currentModuleName:'EinbaurateAnalysis',
               tableData: [],
               date_list :[],
               date_list_tmp :[],             
        }
    },
     methods: {
         ...mapActions('equipanalysis', [
            'queryEinbaurate' 
        ]),
           toPercent(point){ if (point==0) { return 0; } var str=Number(point*100).toFixed(); str+="%"; return str; },
         goto(){
           this.viewResult = !this.viewResult;
         },
         removeDate(index){
          this.date_list_tmp.splice(index,1);
         },
         addDate(){
                 if(this.currentMonth=='') return ;     
                this.date_list_tmp.push(this.currentMonth);
         },
         modifyDate(){
           this.date_list_tmp =[];
           this.date_list_tmp.push(... this.date_list);
           this.showModifyDate = true;
          
         },
         updateData(){
                   this.date_list = []; 
                    this.date_list.push( ... this.date_list_tmp);
                    this.gotoInstalledRatioAnalysis();
         },
         exportExcel(){

           this.JSONToExcelConvertor(this.tableData,"report"); 
         },
        praseTable(){
           let len  = this.tableData.length;     
           //获取大分类  
          var categories = new Set(this.tableData.map(x=>{ return x.tag;  }));
          console.log(categories);
          var dict = new Map();
          categories.forEach(function(value){
               dict.set(value,{startIndex:10000000, endIndex:0});
          });
            var tableCfg  = [...categories].map(x=>{
              return { name:x, startIndex:0, endIndex:0}
            });
           for(var i = 0; i<len; i++)
           {
                let  key  = this.tableData[i].tag; 
                var di =   dict.get(key);       
                  if(di.endIndex <i )
                    {
                     di.endIndex = i;
                    }
                   if(di.startIndex >i )
                    {
                      di.startIndex = i;
                    }                     
           }
           this.tableCfg  =  dict;
        
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
           var cfg = this.tableCfg.get(row.tag);   
            if (columnIndex === 0) {           
            let count = cfg.endIndex - cfg.startIndex+ 1 ;
               if (rowIndex  === cfg.startIndex   ) {
                   return { rowspan: count,  colspan: 1 };
                } else  if(rowIndex > cfg.startIndex && rowIndex<= cfg.endIndex){
                     return { rowspan: 0,  colspan: 0 };
                }              
            }
      },
       setViewResult(isShow)
       {
         this.viewResult = isShow;
      
       },
      gotoInstalledRatioAnalysis()
      {


        var ids  =  this.searchResult.map((item)=>{ return  parseInt(item.id)});
         //  alert(JSON.stringify(ids));
        var postData = {ids:ids,date_list:this.date_list};
       this.queryEinbaurate({params:postData,handle:this.setViewResult});
      },
      bindTable(){
        this.tableData = [];
        for(var item of this.installedRatioList)
         {
        var data  = {tag:item.tag, name:item.name,val :item.val };
        var i = 0;
        for(var dt of this.date_list)
        {
               data[dt] =  this.toPercent(item.data[i].ratio) ;
               i++;
        }
       this.tableData.push(data);  
   
      }
          this.praseTable();
      },
     JSONToExcelConvertor(JSONData, FileName,title,filter) { 
    if(!JSONData) return; 
    //转化json为object 
    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData; var excel = "<table>"; 
    //设置表头  
    var row = "<tr>"; if(title) { 
        //使用标题项 
        for (var i in title) { row += "<th align='center'>" + title[i] + '</th>'; } } else{ 
            //不使用标题项 
            for (var i in arrData[0]) { row += "<th align='center'>" + i + '</th>'; } } excel += row + "</tr>"; 
            //设置数据  
            for (var i = 0; i < arrData.length; i++) { var row = "<tr>"; for (var index in arrData[i]) { 
                //判断是否有过滤行 
                if(filter) { if(filter.indexOf(index)==-1) { var value = arrData[i][index] == null ? "" : arrData[i][index]; row += '<td>' + value + '</td>'; } } else { var value = arrData[i][index] == null ? "" : arrData[i][index]; row += "<td align='center'>" + value + "</td>"; } } excel += row + "</tr>"; } excel += "</table>"; var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>"; excelFile += '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">'; excelFile += '<meta http-equiv="content-type" content="application/vnd.ms-excel'; excelFile += '; charset=UTF-8">'; excelFile += "<head>"; excelFile += "<!--[if gte mso 9]>"; excelFile += "<xml>"; excelFile += "<x:ExcelWorkbook>"; excelFile += "<x:ExcelWorksheets>"; excelFile += "<x:ExcelWorksheet>"; excelFile += "<x:Name>"; excelFile += "{worksheet}"; excelFile += "</x:Name>"; excelFile += "<x:WorksheetOptions>"; excelFile += "<x:DisplayGridlines/>"; excelFile += "</x:WorksheetOptions>"; excelFile += "</x:ExcelWorksheet>"; excelFile += "</x:ExcelWorksheets>"; excelFile += "</x:ExcelWorkbook>"; excelFile += "</xml>"; excelFile += "<![endif]-->"; excelFile += "</head>"; excelFile += "<body>"; excelFile += excel; excelFile += "</body>"; excelFile += "</html>"; var uri = 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(excelFile); var link = document.createElement("a"); link.href = uri; link.style = "visibility:hidden"; link.download = FileName + ".xls"; document.body.appendChild(link); link.click(); document.body.removeChild(link); 
                
      } 
 
      
     },
     created(){
         var myDate = new Date();
         var month  = myDate.getFullYear() +"-" + (myDate.getMonth()+1); 
         this.date_list.push(month);
     },
       computed: {
        ...mapGetters('equipanalysis', {
            'installedRatioList': 'installedRatioList'
        }),
          ...mapGetters('commonsearch', {
            'searchResult': 'selectionResult','savedResultSchemas':'savedResultSchemas','pivotTableKey':'pivotTableKey','showSubmodel':'showSelectionSubmodel'
        }),
    },
    mounted(){
      
 
    },
    watch:{
       viewResult(value)
       {
         if(value)
         {
            this.bindTable();
         }
       },
        installedRatioList(value)
        {
            this.bindTable();
        }
    }
}
</script>
 